// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"962":"036ebca6","990":"79b1a96f"}[chunkId] + ".chunk.css";
};